<!--DASHBOARD PROGRESS CARD CONTAINER-->
<section class="dashboard-progress padding-bottom-large">
  <h3 class="margin-left-large padding-top-large margin-bottom-small">Your Enrollments</h3>

  <ng-template [ngIf]="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </ng-template>

  <ng-template [ngIf]="!isLoading">
    <!--ACTIVE SUBSCRIPTIONS-->
    <!--TODO: Refactor to use accordion component-->
    <ng-container
      *ngIf="
        currentUser &&
          currentUser.activeSubscriptions &&
          currentUser.activeSubscriptions.length > 0;
        else noSubscriptions
      ">
      <ng-container
        *ngFor="
          let subscription of currentUser.activeSubscriptions;
          let last = last;
          let first = first;
          let i = index;
          trackBy: trackBySubscriptionId
        ">
        <ul class="manageEnrollmentContainer padding-bottom-small">
          <!--SUBSCRIPTION CONTAINER-->
          <li
            class="subContainer"
            [ngClass]="{
              'lastSubscriptionDetailContainer': last && i !== 0,
              'subscriptionDetailContainer': !first && !last,
              'firstManySubscriptionDetailContainer':
                first && currentUser.activeSubscriptions.length > 1,
              'firstOnlySubscriptionDetailContainer':
                first && currentUser.activeSubscriptions.length === 1
            }">
            <!--SUBSCRIPTION BASED ICON-->
            <span
              class="icon large red {{
                subscription?.icon
              }} margin-left-large margin-right-small"></span>
            <!--END SUBSCRIPTION BASED ICON-->

            <!--SUBSCRIPTION CONTENT-->
            <div class="subscriptionInfoContainer">
              <h6>Subscription Details</h6>
              <span class="subscriptionNameContainer">
                <!--SUBSCRIPTION NAME-->
                <h4>
                  <ng-container
                    *ngIf="subscription?.linkType === routeTypes.EXTERNAL; else internal">
                    <a
                      class="gen-neutral-black-link"
                      href="{{ subscription?.slugName }}"
                      target="_blank">
                      {{ subscription?.name }}
                    </a>
                  </ng-container>
                  <ng-template #internal>
                    <a
                      class="gen-neutral-black-link"
                      href="javascript:void(0);"
                      [routerLink]="['/subscription', subscription?.slugName]">
                      {{ subscription?.name }}
                    </a>
                  </ng-template>
                </h4>
                <!--SUBSCRIPTION NAME-->
              </span>
            </div>
            <div class="accordion-arrow">
              <a href="javascript:void(0);" (click)="onToggleNavigation(subscription?.slugName)">
                <i
                  class="icon x-small red margin-right-small"
                  [ngClass]="toggleDropdown === subscription?.slugName ? 'arrow-up' : 'arrow-down'">
                </i>
              </a>
            </div>
            <!--SUBSCRIPTION CONTENT-->
          </li>
          <!--END SUBSCRIPTION CONTAINER-->
          <!--SUBSCRIPTION DESCRIPTION-->
          <div class="subscriptionDescriptionContainer">
            <div
              [innerHTML]="subscription?.description | safe : 'html'"
              *ngIf="toggleDropdown === subscription?.slugName"
              class="subscriptionDescription even-smaller-text"></div>
          </div>
          <!--END SUBSCRIPTION DESCRIPTION-->
        </ul>
      </ng-container>
    </ng-container>
    <!--END ACTIVE SUBSCRIPTIONS-->
    <!--SHOW ENROLLMENTS-->
    <ng-container
      *ngIf="
        currentUser && currentUser.enrollments && currentUser.enrollments.length > 0;
        else noEnrollments
      ">
      <ul class="progress-enrollments margin-top-small margin-bottom-small">
        <li
          *ngFor="
            let enrollment of currentUser.enrollments;
            let i = index;
            trackBy: trackByEnrollmentId
          ">
          <!--NOTE: see enrollment.model.ts-->
          <div
            class="progress-enroll-card padding-bottom-small margin-left-small margin-right-small"
            *ngIf="enrollment.canEnter === true">
            <div *ngIf="enrollment?.type === 'learning_plan'">
              <span class="learning-plan icon large margin-right-small red"></span>
            </div>
            <span
              class="medium-text margin-right-small margin-top-small margin-bottom-small"
              [ngClass]="
                enrollment?.type === 'learning_plan'
                  ? 'progress-subscription'
                  : 'progress-course-name'
              ">
              <!--NOTE: See enrolment.model.ts -->
              <div
                *ngIf="
                  enrollment?.enrolledSessions.length > 0;
                  then thenBlock;
                  else elseBlock
                "></div>
              <ng-template #thenBlock>{{ enrollment?.enrolledSessions[0]?.name }}</ng-template>
              <ng-template #elseBlock>{{ enrollment?.name }}</ng-template>
              <span
                class="margin-left-small"
                *ngFor="
                  let session of enrollment.enrolledSessions;
                  let i = index;
                  trackBy: trackBySessionId
                ">
                <!--INFORMATION TOOLTIP-->
                <span
                  [tooltip]="HtmlContent"
                  [theme]="'light'"
                  contentType="template"
                  tooltipClass="tooltip-container"
                  placement="right"
                  maxWidth="400">
                  <i class="cursor icon x-small calendar red"></i>
                </span>
                <!--END INFORMATION TOOLTIP-->
                <!--TOOLTIP TEMPLATE-->
                <ng-template #HtmlContent>
                  <div class="tooltip-content text-align-left">
                    <div><span class="red">Session</span>: {{ session?.name }}</div>
                    <!--NOTE: see session.model.ts and enrollment.model.ts-->
                    <ng-template [ngIf]="enrollment.locationName">
                      <div><span class="red">Location </span>: {{ enrollment?.locationName }}</div>
                    </ng-template>
                    <!--SESSION DATES TOOLTIP-->
                    <div><span class="red">Session Dates</span>:</div>
                    <div>
                      <ul class="dateList">
                        <!--SESSION DATES-->
                        <li
                          class="date"
                          *ngFor="
                            let date of session.dates;
                            let j = index;
                            trackBy: trackByDateIndex
                          ">
                          <!--NOTE: If there is no Session End Time, just show the Session Begin Time-->
                          <div *ngIf="date.time_end; else timeBegin">
                            <!--SHOW TIME-->
                            {{ date.time_begin | utcDateFormat | date : 'MMMM d, y, h:mm:a' }} -
                            {{ date.time_end | utcDateFormat | date : 'h:mm:a (zzzz)' }}
                            <br />
                            {{ date.timezone }}
                          </div>
                          <ng-template #timeBegin>
                            {{
                              date.time_begin | utcDateFormat | date : 'MMMM d, y, h:mm:a (zzzz)'
                            }}
                            {{ date.timezone }}
                          </ng-template>
                        </li>
                        <!--END SESSION DATES-->
                      </ul>
                    </div>
                    <!--END SESSION DATES TOOLTIP-->
                  </div>
                </ng-template>
                <!--END TOOLTIP TEMPLATE-->
              </span>
            </span>
            <!--ENROLLED MESSAGE BUTTON-->
            <a
              class="list btn btn-primary"
              [ngClass]="{
                'inactive':
                  enrollment.enrolledMessage === enrollmentMessage.WAITLIST ||
                  enrollment.enrolledMessage === enrollmentMessage.VIEW ||
                  enrollment.enrolledMessage === enrollmentMessage.VIEW_DETAILS ||
                  enrollment.enrolledMessage === enrollmentMessage.REVIEW,
                'small-list': enrollment.enrolledSessions.length > 0
              }"
              target="_blank"
              rel="noopener noreferrer nofollow"
              href="{{ environment.docebo.url }}{{
                enrollment.url
              }};type=oauth2_response;access_token={{ accessToken?.access_token }};expires_in={{
                accessToken?.expires_in
              }};token_type=bearer;scope=api">
              {{
                enrollment.enrolledMessage ? enrollment.enrolledMessage : enrollmentMessage.START
              }}
            </a>
            <!--END ENROLLED MESSAGE BUTTON-->
            <!-- UNENROLLED MESSAGE BUTTON-->
            <ng-container *ngIf="enrollment.enrolledSessions.length > 0">
              <a
                class="small-list btn btn-inverse"
                (click)="
                  openUnenrollSessionModal(true, enrollment.id, enrollment.enrolledSessions[0])
                ">
                {{ cardTypeCallToActions.UNENROLL }}
              </a>
            </ng-container>
            <!--END UNENROLLED MESSAGE BUTTON-->
          </div>
        </li>
      </ul>
    </ng-container>
    <!--END ENROLLMENTS-->
    <!--NO ENROLLMENTS MESSAGE-->
    <ng-template #noEnrollments>
      <p class="margin-left-large margin-top-large">You have no active enrollments.</p>
    </ng-template>
    <!--END NO ENROLLMENTS MESSAGE-->
  </ng-template>
</section>
<!--END DASHBOARD PROGRESS CARD CONTAINER-->

<!--UNENROLLED SESSION MESSAGE INSTRUCTIONS-->
<app-modal-dialog
  #modalDialog
  [containerID]="'unEnrolledContent'"
  [modalMaxWidth]="'modal-max-width-medium'">
  <div #modalContainer>
    <app-confirm-dialog
      [title]="'Unenrollment'"
      [message]="'Are you sure you want to unenroll from <strong>' + sessionName + '</strong> ?'"
      (confirmClicked)="unEnrollSession()">
    </app-confirm-dialog>
  </div>
</app-modal-dialog>
<!--END UNENROLLED SESSION MESSAGE INSTRUCTIONS-->
<!--NO SUBSCRIPTIONS MESSAGE-->
<ng-template #noSubscriptions>
  <p class="margin-left-large margin-top-large">
    You do not have any active subscriptions. If this incorrect, please contact
    <a class="gen-primary-link--accesible with-underline" href="mailto:education@genesys.com"
      >education&#64;genesys.com</a
    >.
  </p>
</ng-template>
<!--END NO SUBSCRIPTIONS MESSAGE-->
